
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="col-span-1 md:col-span-2"
          >
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社バン
            </h3>
            <p className="text-gray-300 mb-4">
              ADVERTISING AGENCY VAN CO., LTD
            </p>
            <p className="text-gray-300 text-sm">
              設立1965年 - 群馬の老舗広告会社<br />
              新日東グループの総合力で企業の困りごとにお応えします。
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>広告企画・制作</li>
              <li>イベントプロデュース</li>
              <li>デジタルマーケティング</li>
              <li>WEB・アプリ開発</li>
              <li>サイン・看板工事</li>
            </ul>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <div className="text-gray-300 text-sm space-y-2">
              <p>〒371-0854<br />群馬県前橋市大渡町1-23-13</p>
              <p>
                TEL: <a href="tel:027-255-2214" className="text-blue-400 hover:text-blue-300 cursor-pointer transition-colors">027-255-2214</a>
              </p>
              <p>FAX: 027-255-2324</p>
              <p>
                <a href="mailto:infovan@shinnitto.jp" className="text-blue-400 hover:text-blue-300 cursor-pointer transition-colors">infovan@shinnitto.jp</a>
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm"
        >
          <p>&copy; 2024 株式会社バン. All rights reserved.</p>
        </motion.div>
      </div>
    </footer>
  );
}